import ToggleSwitch from "@components/Home/ToggleSwitchLang/ToggleSwitchLang";
import { Stack } from "@mui/material";
import { StackLogo, Title } from "@pages/auth/login/Login.style";
import { LogoLetter } from "assets/icons/LogoLetter";
import React from "react";
import { useTranslation } from "react-i18next";

import PaymentForm from "@components/PaymentForm/PaymentForm";
import { useLocation } from "react-router-dom";
const Payment = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const formData = location.state;
  console.log("🚀 ~ Payment ~ formData:", formData);

  return (
    <Stack>
      <ToggleSwitch />

      <StackLogo gap={2}>
        <StackLogo>
          <LogoLetter />
          <Title>{t("payment.title")}</Title>
        </StackLogo>

        {/* TODO: to make payment works uncomment this! */}
        {/* <PaiementFormClient formData={formData} /> */}

        <PaymentForm formData={formData} />
      </StackLogo>
    </Stack>
  );
};

export default Payment;
